import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="py-24 px-6 bg-brand-cream" data-id="element-174">
      <div className="max-w-5xl mx-auto" data-id="element-175">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-brand-purple mb-16 text-center" data-id="element-176">
          Lo que dicen quienes ya lo tienen
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-177">
          {/* Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-brand-white rounded-3xl p-8 shadow-lg border border-brand-purple/5" data-id="element-178">
            <div className="flex items-center gap-4 mb-6" data-id="element-179">
              <div className="w-14 h-14 rounded-full bg-brand-purple text-brand-white flex items-center justify-center font-serif font-bold text-xl" data-id="element-180">
                MG
              </div>
              <div data-id="element-181">
                <h4 className="font-bold text-brand-purple font-sans" data-id="element-182">
                  María G.
                </h4>
                <p className="text-sm text-gray-500 font-sans" data-id="element-183">
                  Esteticista, Buenos Aires
                </p>
              </div>
            </div>
            <div className="flex gap-1 mb-4" data-id="element-184">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-185" />)}
            </div>
            <p className="text-gray-700 font-sans leading-relaxed italic" data-id="element-186">
              "Llevaba 4 años trabajando sin contratos ni protocolos escritos.
              En la primera semana de usar el Megapack ya tenía todo
              documentado. Mis clientas lo notan — el nivel de profesionalismo
              cambió por completo."
            </p>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-white rounded-3xl p-8 shadow-lg border border-brand-purple/5" data-id="element-187">
            <div className="flex items-center gap-4 mb-6" data-id="element-188">
              <div className="w-14 h-14 rounded-full bg-brand-gold text-brand-white flex items-center justify-center font-serif font-bold text-xl" data-id="element-189">
                LC
              </div>
              <div data-id="element-190">
                <h4 className="font-bold text-brand-purple font-sans" data-id="element-191">
                  Laura C.
                </h4>
                <p className="text-sm text-gray-500 font-sans" data-id="element-192">
                  Esteticista, Córdoba
                </p>
              </div>
            </div>
            <div className="flex gap-1 mb-4" data-id="element-193">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-194" />)}
            </div>
            <p className="text-gray-700 font-sans leading-relaxed italic" data-id="element-195">
              "La calculadora de rentabilidad me mostró que estaba cobrando
              $8.000 menos por sesión de lo que debería. Subí los precios con el
              sistema del Tomo 02 y no perdí ninguna clienta."
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}